export const isInterventionWithEvents = ({ type, payload }) =>
  type.match(/intervention(?!s).*success/i) !== null && Array.isArray(payload?.events);
